







































































































import {Component, Mixins, Watch} from 'vue-property-decorator'
import {MixinRouteMatch} from '@/components/mixins/MixinRouteMatch'
import {GithubRepositoryCommit} from '@/model/resource/GithubRepositoryCommit'
import {GithubRepositoryCommitCollection} from '@/model/collection/GithubRepositoryCommitCollection'
import {ListGithubRepositoryCommitSchema} from '@/schema/resource/GithubRepositoryCommit/ListGithubRepositoryCommitSchema'

@Component({
  components: {},
})
export default class ListGithubRepositoryCommitView extends Mixins(
  MixinRouteMatch
) {
  schema = new ListGithubRepositoryCommitSchema()
  collection = new GithubRepositoryCommitCollection()

  async created() {
    if (this.hasQueryParams) {
      this.updateObjectFromRoute(this.collection)
    }

    await this.$await.run('hardQuery', () => this.collection.queryAsPage())
  }

  async removeItem(item: GithubRepositoryCommit) {
    await this.$dialog.remove(item)
    await item.removeGithubRepositoryCommit()
    await this.collection.queryAsPage()
  }

  goToPersistView(item: GithubRepositoryCommit) {
    this.$nav.pushByName('editGithubRepositoryCommit', item.$id)
  }

  @Watch('collection', {deep: true})
  collectionEvent() {
    this.updateRouteFromObject(this.collection)
  }
}
